import { render, staticRenderFns } from "./GinView.vue?vue&type=template&id=d0d13a60&scoped=true"
import script from "./GinView.vue?vue&type=script&lang=js"
export * from "./GinView.vue?vue&type=script&lang=js"
import style0 from "./GinView.vue?vue&type=style&index=0&id=d0d13a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d13a60",
  null
  
)

export default component.exports